import * as angular from "angular";
import {IController} from "angular";

export class ProgramVehiclesTaskCancellationFeesTableComponent implements IController {
  cancellationFees: any;
  isExpanded: boolean;
  isEdit: boolean;
  statuses: string[];
  excludedStatuses: string[]
  onUpdateCancellationFee: Function;
  onDeleteCancellationFee: Function;

  public dataReferenceId: string;

  constructor() {
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesTaskCancellationFeesTable', {
    require: {
      form: '^form'
    },
    bindings: {
      cancellationFees: '<',
      isExpanded: '<?',
      isEdit: '<?',
      statuses: '<?',
      excludedStatuses: '<',
      onUpdateCancellationFee: '&',
      onDeleteCancellationFee: '&'
    },
    template: require('./program-vehicles-task-cancellation-fees-table.html').default,
    controller: ProgramVehiclesTaskCancellationFeesTableComponent
  });
